/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SettingsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export const ConsentErrorTypename =
  'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export type ConsentError = {
  reason: ConsentErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.ConsentError';
} & { '@type'?: 'CONSENT' };

export const NotificationErrorTypename =
  'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export type NotificationError = {
  reason: NotificationErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.NotificationError';
} & { '@type'?: 'NOTIFICATION' };

export const PortalAuthErrorTypename =
  'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export type PortalAuthError = {
  reason: PortalAuthErrorReason;
  portalInstanceId?: number;
  denialReason?: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
} & { '@type'?: 'AUTH' };

export const PortalPublicRpcErrorDiscriminantKey = '@type';
export type PortalPublicRpcError =
  | PortalAuthError
  | NotificationError
  | ConsentError
  | SettingsError
  | SupportPortalError;

export const SettingsErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export type SettingsError = {
  reason: SettingsErrorReason;
  passwordErrors: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SettingsError';
} & { '@type'?: 'SETTINGS' };

export const SupportPortalErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export type SupportPortalError = {
  reason: SupportPortalErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
} & { '@type'?: 'SUPPORT_PORTAL' };

export type ConsentErrorReason =
  | 'CONSENT_LABELS_NOT_FOUND'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type NotificationErrorReason =
  | 'NOTIFICATION_NOT_FOUND'
  | 'INVALID_NOTIFICATION_TYPE'
  | 'MISSING_PORTAL_ID'
  | 'INVALID_NOTIFICATION_NAME'
  | 'INVALID_TARGET'
  | 'PORTAL_INSTANCE_NOT_FOUND'
  | 'HUBSPOT_NOTIFICATION_SEND_FAILED'
  | unhandledEnumCase;

export type PortalAuthErrorReason =
  | 'AUTHENTICATION_FAILED'
  | 'ACCESS_DENIED'
  | 'UNEXPECTED_ERROR'
  | 'INVALID_PARAMETER_COUNT'
  | 'INVALID_PARAMETER_TYPES'
  | 'MISSING_ACCOUNT_ID'
  | 'MISSING_PORTAL_INSTANCE_ID'
  | 'MISSING_MEMBERSHIP_COOKIE'
  | 'EMPTY_MEMBERSHIP_COOKIE'
  | 'CSRF_ERROR'
  | 'MISSING_CRM_OBJECT_ID'
  | 'MISSING_CRM_OBJECT_ASSOCIATION'
  | 'FORM_NOT_FOUND'
  | unhandledEnumCase;

export type SettingsErrorReason =
  | 'MISSING_REQUIRED_FIELD'
  | 'CONTACT_NOT_FOUND'
  | 'FILE_TOO_LARGE'
  | 'UNSUPPORTED_FILE_TYPE'
  | 'WRONG_CURRENT_PASSWORD'
  | 'INVALID_PASSWORD'
  | 'SAME_PASSWORD'
  | 'PASSWORD_LEAKED'
  | 'PASSWORDS_DO_NOT_MATCH'
  | 'RATE_LIMITED'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type SupportPortalErrorReason =
  | 'SETTINGS_NOT_FOUND'
  | 'TICKET_NOT_FOUND'
  | 'THREAD_NOT_FOUND'
  | 'CONTACT_NOT_FOUND'
  | 'RESOURCE_NOT_FOUND'
  | unhandledEnumCase;

export type ChangePasswordRequest = {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
};

export type ChangePasswordResponse = {};

export type GetUserSettingsRequest = {
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
};

export type GetUserSettingsResponse = {
  email?: string;
  firstName?: string;
  lastName?: string;
  jobTitle?: string;
  phone?: string;
  company?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  preferredLanguage?: string;
};

export type UpdateUserSettingsRequest = {
  preferredLanguage?: string;
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
};

export type UpdateUserSettingsResponse = {
  firstName?: string;
  lastName?: string;
  jobTitle?: string;
  phone?: string;
  preferredLanguage?: string;
};

export type UploadProfilePhotoRequest = {
  imageData: string;
  contentType: string;
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
};

export type UploadProfilePhotoResponse = { avatarUrl: string };

export type GetUserSettingsRequestType = Requestify<GetUserSettingsRequest>;
export type GetUserSettingsResponseType = GetUserSettingsResponse;
export type GetUserSettingsErrorType = PortalPublicRpcError & HubspotMetadata;
export const getUserSettingsRpc: ChirpAvroRpcDetails<
  GetUserSettingsRequestType,
  GetUserSettingsResponseType,
  GetUserSettingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'getUserSettings',
  auth: 'external',
  fingerprint: '0uJzqBrWuix7iXgmBHC4L2qVobnnONkj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateUserSettingsRequestType =
  Requestify<UpdateUserSettingsRequest>;
export type UpdateUserSettingsResponseType = UpdateUserSettingsResponse;
export type UpdateUserSettingsErrorType = PortalPublicRpcError &
  HubspotMetadata;
export const updateUserSettingsRpc: ChirpAvroRpcDetails<
  UpdateUserSettingsRequestType,
  UpdateUserSettingsResponseType,
  UpdateUserSettingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'updateUserSettings',
  auth: 'external',
  fingerprint: 'rQksUFSH9bcaOvFy28zRj2qVobnnONkj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UploadProfilePhotoRequestType =
  Requestify<UploadProfilePhotoRequest>;
export type UploadProfilePhotoResponseType = UploadProfilePhotoResponse;
export type UploadProfilePhotoErrorType = PortalPublicRpcError &
  HubspotMetadata;
export const uploadProfilePhotoRpc: ChirpAvroRpcDetails<
  UploadProfilePhotoRequestType,
  UploadProfilePhotoResponseType,
  UploadProfilePhotoErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'uploadProfilePhoto',
  auth: 'external',
  fingerprint: '8m1VJHs3RETEwi6COxqKI2qVobnnONkj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ChangePasswordRequestType = Requestify<ChangePasswordRequest>;
export type ChangePasswordResponseType = ChangePasswordResponse;
export type ChangePasswordErrorType = PortalPublicRpcError & HubspotMetadata;
export const changePasswordRpc: ChirpAvroRpcDetails<
  ChangePasswordRequestType,
  ChangePasswordResponseType,
  ChangePasswordErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SettingsRpc',
  rpcName: 'changePassword',
  auth: 'external',
  fingerprint: '-tFP3AgKAMKBwHLCj2DS12qVobnnONkj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
